<template>
    <div class="rzy-page">

        <div class="rzy-top-bar">
        	<el-button type="primary" @click="initPrint('localListTableId')" size="default" icon="el-icon-printer">打印
        	</el-button>
        </div>

        <div style="margin-top: 10px;">
        </div>
		
		<div id="localListTableId">
			<el-table :data="responseData" style="width: 100%;margin-bottom: 20px;margin-top:10px;" 
			:header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle" show-summary :summary-method="getSummaries"
			row-key="id" border default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column prop="names" label="仓库/仓位">
				</el-table-column>
				<el-table-column prop="materialName" label="物料名称" sortable align="center">
				</el-table-column>
				<el-table-column prop="materialNumber" label="物料编号" sortable align="center">
				</el-table-column>
				<el-table-column prop="weight" label="过磅重量(千克)" sortable align="center">
				</el-table-column>
				<el-table-column prop="meter" label="米数(米)" sortable align="center">
				</el-table-column>
				<el-table-column prop="number" label="数量(匹)" sortable align="center">
				</el-table-column>
			</el-table>
		</div>

    </div>
</template>

<script>
	import printJS from 'print-js'
    export default {
        data() {
            return {
                //分页 -- sta
                pageInfo: {
					materialId: this.$route.query.materialId,
                    page: 1,
                    size: 9999,
                },
                totalPages: 0,
                //分页 -- end
				querymaterialname:this.$route.query.materialName,
				querymaterialNumber:this.$route.query.materialNumber,

                responseData: [
                    // 调试用假数据--正式版注释掉
                    
                ],
            }
        },
        methods: {

            // 分页切换
            handleCurrentChange(newNum) {
                this.getPeiBuList(newNum)
            },

            // 刷新
            refreshPage() {
                this.getList(1)
                this.$Message.success('刷新成功')
            },

            // 获取XX分页列表
            getList(val) {
                this.pageInfo.page = val
                this.$requestBase({
                    url: '/v1/stock/list',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.responseData = this.formatResponse(res.data.list)
                    this.totalPages = res.data.pages
					console.log(this.formatResponse(res.data.list))
                })
            },
            // 格式化XX列表
            formatResponse(response) {
				let responseData = []
                response.forEach((item, index) => {
					let res = this.checkresponseData(responseData,item.warehouseName,item.positionName)
					console.log(res)
					
					if(res.type=='warehouseName'){
						let data = {
							id:res.id,
							names:item.warehouseName,
							materialName: this.querymaterialname,
							materialNumber:this.querymaterialNumber,
							weight: Number((item.productWeight/1000).toFixed(2)),
							meter: Number((item.productLength/100).toFixed(2)),
							number: item.count,
							children:[{
								id:res.id*10+1,
								names:item.positionName,
								materialName: this.querymaterialname,
								materialNumber:this.querymaterialNumber,
								weight: Number((item.productWeight/1000).toFixed(2)),
								meter: Number((item.productLength/100).toFixed(2)),
								number: item.count,
							}]
						}
						responseData.push(data)
					}else if(res.type=='positionName'){
						let childrendata = {
							id:res.childrenid,
							names:item.positionName,
							materialName: this.querymaterialname,
							materialNumber:this.querymaterialNumber,
							weight: Number((item.productWeight/1000).toFixed(2)),
							meter: Number((item.productLength/100).toFixed(2)),
							number: item.count,
						}
						responseData[res.id].weight += Number((item.productWeight/1000).toFixed(2))
						responseData[res.id].meter += Number((item.productLength/100).toFixed(2))
						responseData[res.id].number += item.count
						responseData[res.id].children.push(childrendata)
					}
					console.log(responseData)
                })
                return responseData
            },
			checkresponseData(responseData,warehouseName,positionName){
				let i=0
				for(; i<responseData.length; i++){
					if(responseData[i].names == warehouseName){
						let p=0
						for(; p<responseData[i].children.length; p++){
							if(responseData[i].children[p].names == positionName){
								return {type:'None'}
							}
						}
						return {id:i,childrenid:(i+1)*10+p+1,type:'positionName'}
					}
				}
				return {id:i+1,type:'warehouseName'}
			},
            //给 所有 表格 自动 加行号
            indexMethod(index) {
                return index + 1;
            },
			setCellStyle({ row, column, rowIndex, columnIndex }) {
				  
			    let that = this;
			    let columns = [1,2,3,4,5]; //想要改变列的索引
				if(columnIndex === 0){
					return "text-align:left;";
				}
			    if (columns.indexOf(columnIndex) > -1) { //有出现的话就返回center
			        return "text-align:center;";
			    } else {
			        return "text-align:left;padding-left:15px;"; //没有的话就返回left
			    }
			},
			setHeaderCellStyle({ row, column, rowIndex, columnIndex }) {		  
			    let that = this;
			    let columns = [1,2,3,4,5]; //想要改变列的索引
				if(columnIndex === 0){
					return "text-align:left;";
				}
			    if (columns.indexOf(columnIndex) > -1) { //有出现的话就返回center
			        return "text-align:center;";
			    } else {
			        return "text-align:left;padding-left:15px;"; //没有的话就返回left
			    }
			},
			getSummaries(param) {
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						switch(index){
							case 3:sums[index] += ' 千克';break;
							case 4:sums[index] += ' 米';break;
							case 5:sums[index] += ' 匹';break;
						}
					} else {
						sums[index] = '';
					}
				});
	
				return sums;
			},
			// 在打印当前报表前，拼接title
			initPrint(id) {
				printJS({
					// printable: 'pageDetail', type: 'html', targetStyles: ['*'], maxWidth: 1100, scanStyles: true
					printable: id, 
					type: 'html', 
					targetStyles: ['*'], 
					maxWidth: 1100, 
					scanStyles: true,
					header: '物料明细',
					           // style: `@page {size:auto;margin-top:100px; margin-left:15px; margin-right: 15px;}
					           //  thead th {
					           //    border-top: 2px solid #000;
					           //    border-right: 2px solid #000;
					           //    border-left: 2px solid #000;
					           //  }
					           //  tbody td {
					           //    border: 2px solid #000;
					           //  }
					           //  tbody {
					           //    text-align: center;
					           //  }
					           //  table {
					           //    border-collapse: collapse;
					           //  }`,					
				})
				return
			    this.utils.printTable(id, `物料明细`)
				
			},
        },
        created() {},
        mounted() {

            this.getList(1)
        },
    }
</script>

<style scoped lang="scss">

</style>